import { useNavigate, useSearchParams } from 'react-router-dom';
import { forgotPassword } from 'services/auth';
import { useCallback } from 'react';
import { useFlash } from 'contexts/flash';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

export const useInjection = () => {
  const { setFlash } = useFlash();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const handleResetLink = useCallback(async () => {
    const email = searchParams.get('email');
    if (!email) return;
    await forgotPassword(email);
    setFlash({ type: 'success', message: 'Request sent successfully!' });
  }, [searchParams, setFlash]);
  const { asyncCallback, isLoading } = useAsyncCallback(handleResetLink, []);
  const navigateLogin = () => navigate('/login');
  return { handleResetLink: asyncCallback, navigateLogin, isLoading };
};
